import {ApolloProvider} from "@apollo/client";
import classnames from "classnames";
import {PropsWithChildren} from "react";

import client from "@/lib/api/apolloClient.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {Hero} from "@/pages/auth/layout/Hero.tsx";
import {NavBar} from "@/pages/auth/layout/NavBar.tsx";
import {StepsBar} from "@/pages/auth/layout/StepsBar.tsx";

import styles from "./Layout.module.scss";

export const Layout = ({children}: PropsWithChildren) => (
  <UpErrorBoundary>
    <ApolloProvider client={client}>
      <div className="mx-auto">
        <NavBar />
        <StepsBar
          steps={[
            {name: "Pick a plan", completed: true},
            {name: "Checkout", completed: false},
          ]}
        />
        <Hero className="my-4" />
        <div className={classnames("container-fluid mt-4", styles.containerContents)}>{children}</div>
      </div>
    </ApolloProvider>
  </UpErrorBoundary>
);
